export const passwordRepeat = () => ({
  error: false,
  value: '',
  showPassword: false,
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.$refs.input.type = this.showPassword ? 'text' : 'password';
    this.$refs.input.focus();
  },
  onInvalid(event) {
    event.preventDefault();
    this.error = true;
  },
  validate() {
    const password =
      (document.querySelector('[data-password]') as HTMLInputElement) || null;
    if (password.value !== this.value) {
      this.$refs.input.setCustomValidity('Passwörter stimmen nicht überein.');
      this.error = true;
    } else {
      this.$refs.input.setCustomValidity('');
      this.error = false;
    }
  },
  init() {
    const password =
      (document.querySelector('[data-password]') as HTMLInputElement) || null;
    password.addEventListener('input', () => {
      this.validate();
    });
  },
});
